import { render, staticRenderFns } from "./login-otp-form.vue?vue&type=template&id=1d60c5f6&scoped=true&"
import script from "./login-otp-form.component.ts?vue&type=script&lang=ts&"
export * from "./login-otp-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./login-otp-form.scss?vue&type=style&index=0&id=1d60c5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60c5f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d60c5f6')) {
      api.createRecord('1d60c5f6', component.options)
    } else {
      api.reload('1d60c5f6', component.options)
    }
    module.hot.accept("./login-otp-form.vue?vue&type=template&id=1d60c5f6&scoped=true&", function () {
      api.rerender('1d60c5f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/components/login-otp-form/login-otp-form.vue"
export default component.exports